import React from 'react';
import { COPILOT_PANEL_WIDTH } from '@components/Copilot/constants';
import { AiMagic } from '@fabric-ui/icons';
import { flex, shadowSecondaryBottomMd } from '@fabric-ui/theme';
import { Box } from '@mui/material';

interface IDefaultPromptItem {
  prompt: string;
  onClick: () => void;
  disabled?: boolean;
}

const DefaultPromptItem: React.FC<IDefaultPromptItem> = ({ prompt, onClick, disabled = false }) => (
  <Box
    onClick={disabled ? undefined : onClick}
    sx={{
      cursor: disabled ? 'default' : 'pointer',
      width: '100%',
      maxWidth: COPILOT_PANEL_WIDTH - 48,
      ...flex.itemsStart,
      gap: 0.5,
      px: 1.5,
      py: 2,
      borderRadius: '12px',
      border: '2px solid var(--color-border-base-primary)',
      wordBreak: 'break-word',
      transition: theme => theme.transitions.create(['box-shadow'], { duration: theme.transitions.duration.shorter }),
      ...(disabled
        ? { opacity: 0.5 }
        : {
            '&:hover': {
              backgroundColor: theme => theme.palette.white.main,
              boxShadow: shadowSecondaryBottomMd,
            },
          }),
    }}>
    <AiMagic />
    {prompt}
  </Box>
);

const MemoizedDefaultPromptItem = React.memo(DefaultPromptItem, (oldProps, newProps) => oldProps.prompt === newProps.prompt);

export default MemoizedDefaultPromptItem;
